module.exports = __webpack_public_path__ + "img/pr-4.966f4d6c.png";